module.exports = __webpack_public_path__ + "img/bg5.6ff95d94.jpg";